import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import analyticsReducer from './slices/analyticsSlice';
import portfolioReducer from './slices/portfolioSlice';
import archiveReducer from './slices/archiveSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import designersReducer from './slices/designersSlice';
import searchReducer from './slices/searchSlice';
import tryOnReducer from './slices/tryOnSlice';
import academyReducer from './slices/academySlice';
import productsReducer from './slices/productsSlice';
import creatorStoreReducer from './slices/storeSlice';
import productMediaReducer from './slices/productMediaSlice';
import favoritesReducer from './slices/favoritesSlice';
import rfqReducer from './slices/rfqSlice';
import currencyReducer from './slices/currencySlice';
import crmReducer from './slices/crmSlice';

const rootReducer = {
  auth: authReducer,
  analytics: analyticsReducer,
  portfolio: portfolioReducer,
  archive: archiveReducer,
  subscription: subscriptionReducer,
  designers: designersReducer,
  search: searchReducer,
  tryOn: tryOnReducer,
  academy: academyReducer,
  products: productsReducer,
  creatorStore: creatorStoreReducer,
  productMedia: productMediaReducer,
  favorites: favoritesReducer,
  rfq: rfqReducer,
  currency: currencyReducer,
  crm: crmReducer,
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 